import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button, Select } from '@/ui';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 1.5rem;
  width: 100%;
  padding: 2rem 0;
`;

export const StyledTitle = styled.div`
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`;

export const StyledCommentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`;

export const StyledCommentHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledUserNameWrapper = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const StyledUserName = styled.div`
  ${pickThemeFontStyles('16', '24', 'BOLD')};
`;

export const StyledUserRole = styled.div<{ $isAdmin: boolean }>`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  background: ${({ $isAdmin }) => ($isAdmin ? `${COLORS.YELLOW_PRIMARY}33` : `${COLORS.PURPLE}1A`)};
  border-radius: 1.6875rem;
  padding: 0.25rem 0.75rem;
`;

export const StyledDate = styled.div`
  color: ${COLORS.IRON_GRAY};
  ${pickThemeFontStyles('12', '22', 'NORMAL')};
`;

export const StyledCommentText = styled.div<{ $isCancellation?: boolean }>`
  color: ${({ $isCancellation }) => ($isCancellation ? COLORS.RED : COLORS.CHARCOAL)};
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
`;

export const StyledAddCommentBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  &&& .ant-form-item-label {
    padding: 0;
  }

  &&& label {
    ${pickThemeFontStyles('12', '16', 'NORMAL')};
    color: ${COLORS.IRON_GRAY};
  }

  &&& textarea {
    background: transparent;
    ${pickThemeFontStyles('16', '24', 'NORMAL')};
    color: ${COLORS.CHARCOAL};
  }

  &&& button:disabled {
    opacity: 0.5;
  }
`;

export const StyledQuickCommentsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`;

export const StyledQuickCommentsLabel = styled.span`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.IRON_GRAY};
`;

export const StyledQuickCommentsSelect = styled(Select)`
  width: 100%;
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;
